import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { catchError, map } from "rxjs/operators";
import { Observable, throwError,  of as observableOf, } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";


@Injectable({
  providedIn: 'root'
})
export class FolderService {

  private ENDPOINT_FOLDERS: string = '/folders';
  private ENDPOINT_REPORTS: string = '/dremio/reports';
  constructor(private http: HttpClient) { }

  getFoldersList() {
    // let params = new HttpParams();
    // params = params
    //     .set("page", "1")
    //     .set("perPage", "50");

    return this.http
      .get(environment.report_url + this.ENDPOINT_FOLDERS + '/accessible', {observe: 'response'})
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getFolderById(folderId: string):Observable<any>{
    return this.http
      .get(environment.report_url + this.ENDPOINT_FOLDERS +'/'+folderId, {observe: 'response'})
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  createFolder(folderData: any): Observable<any> {
    let options: any = { observe: 'response' };
    return this.http
      .post(environment.report_url + this.ENDPOINT_FOLDERS, folderData, options)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  updateFolder(folderData: any, action: string): Observable<any> {
    let apiUrl: string;
    if (action === 'share'){
      apiUrl = environment.report_url + this.ENDPOINT_FOLDERS + '/share';
    }
    else{
      apiUrl = environment.report_url + this.ENDPOINT_FOLDERS;
    }

    let options: any = { observe: 'response' };
    return this.http
      .put(apiUrl, folderData, options)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  deleteFolder(folderId: string):Observable<any>{
    let options: any = { observe: 'response' };
    return this.http.delete(environment.report_url + this.ENDPOINT_FOLDERS + '/' + folderId, options).pipe(map((resp: any) => {
      return resp;
    }
    ), catchError(error => {
      //console.log(error);
      return throwError(error);
    }),);
  }

  getReportsByFolder(folderId: number, apiParams: any): Observable<any>{
    let params = new HttpParams();
    params = params.set("folderId",folderId);

    if (apiParams.search ) {
      params = params.set("search", apiParams.search);
    }
    
    if (apiParams.startFrom){
      params = params.set("startFrom", apiParams.startFrom);
    }

    if (apiParams.page){
      params = params.set("page", apiParams.page);
    }
    if (apiParams.perPage){
      params = params.set("perPage", apiParams.perPage);
    }

    if (apiParams.columnName){
      params = params.set("columnName", apiParams.columnName);
      params = params.set("sortOrder", apiParams.sortOrder);
    }
  
    let options: any = {params: params };

    return this.http
      .get(environment.report_url + this.ENDPOINT_REPORTS + '/folder-accessible', options)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getFavoriteReports(apiParams: any): Observable<any>{
    let params = new HttpParams();
    if (apiParams.search ) {
      params = params.set("search", apiParams.search);
    }
    
    if (apiParams.startFrom){
      params = params.set("startFrom", apiParams.startFrom);
    }

    if (apiParams.page){
      params = params.set("page", apiParams.page);
    }
    if (apiParams.perPage){
      params = params.set("perPage", apiParams.perPage);
    }

    if (apiParams.columnName){
      params = params.set("columnName", apiParams.columnName);
      params = params.set("sortOrder", apiParams.sortOrder);
    }
  
    let options: any = {params: params };
    //api/dremio/reports/favorites?page=1&perPage=25&startFrom=0&columnName=id&sortOrder=DESC
    return this.http
      .get(environment.report_url + this.ENDPOINT_REPORTS + '/favorites', options)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }
}
